import { useMemo } from 'react';
import { useGoodsBasic } from '../../../queries/useGoodsBasic';
import { useGoodsDetail } from '../../../queries/useGoodsDetail';
import { useCountdownDisplay } from '../../GoodsInfo/components/PromotionCountdown/hooks/useCountdownDisplay';
import {
  resolveBottomDockedTimeSaleBanner,
  type BottomDockedTimeSaleBanner,
} from '../utils/resolveBottomDockedTimeSaleBanner';

/**
 * 하단 도킹에 노출할 타임세일 배너. 없으면 null → NudgeVerticalCarousel.
 * 표시 중 만료되면 tick으로 null이 되어 넛지로 복귀한다.
 */
export const useBottomDockedTimeSaleBanner =
  (): BottomDockedTimeSaleBanner | null => {
    const { data: goodsDetail } = useGoodsDetail();
    const { data: goodsBasic } = useGoodsBasic();

    const candidate = useMemo(
      () =>
        resolveBottomDockedTimeSaleBanner({
          promotionCountdown:
            goodsBasic?.price_description?.promotion_countdown ?? null,
          timeSaleBanner: goodsDetail?.time_sale_banner ?? null,
        }),
      [
        goodsBasic?.price_description?.promotion_countdown,
        goodsDetail?.time_sale_banner,
      ],
    );

    // candidate 없을 때도 hook 규칙상 호출. '' → isExpired라 결과엔 영향 없음.
    const { isExpired } = useCountdownDisplay(candidate?.finishedAt ?? '');

    if (!candidate || isExpired) return null;
    return candidate;
  };
